import { render, staticRenderFns } from "./AccessStatusBadge.vue?vue&type=template&id=22642a3a&scoped=true"
import script from "./AccessStatusBadge.vue?vue&type=script&lang=js"
export * from "./AccessStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./AccessStatusBadge.vue?vue&type=style&index=0&id=22642a3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22642a3a",
  null
  
)

export default component.exports